import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../stem-core/src/ui/Style";

import {StepDescription} from "../StepDescription";
import {authService} from "../../../../client/connection/Services";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {Messages} from "../../../Messages";
import {MerchantButton} from "../../../common/MerchantButton";
import {PanelChooseCard} from "../../pages/panels/donation/components/PanelChooseCard";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PoweredByBlink} from "../../PoweredByBlink";
import {PaymentMethodStore} from "../../../State";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {donateMobileState} from "../../inline-donation/DonateMobileState";


class PayWithChosenCardPanelStyle extends StyleSheet {
    @styleRule
    title = {
        ...this.themeProps.DONATE_PAGE_CARD_TITLE,
        marginBottom: 6,
    };

    @styleRule
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        margin: "20px 0 8px",
    };
}

@registerStyle(PayWithChosenCardPanelStyle)
export class PayWithChosenCardPanel extends UI.Element {
    render() {
        const {styleSheet} = this;

        return [
            <StepDescription backFunction={() => this.options.changeURL(authService.isAuthenticated() ?
                                    DONATE_PAGE_URLS.donate : DONATE_PAGE_URLS.auth, true)}
                             currentStep={StepDescription.stepCount} stepDescription={Messages.paymentStep}/>,
            <div className={styleSheet.title}>{Messages.paymentDetails}</div>,
            <PanelChooseCard hideActiveCard={true} addCardButtonLabel={Messages.addNewCard} ref="chooseCard"
                             selected={PaymentMethodStore.getPrimary()} onCardSelected={() => this.redraw()}
                             onAddCard={() => this.options.changeURL(DONATE_PAGE_URLS.payWithAddedCard)}/>,
            <MerchantButton className={styleSheet.button} disabled={this.chooseCard && !this.chooseCard.getActive()}
                            onClick={() => this.donate()}>
                {Messages.finalizePayment}
            </MerchantButton>,
            <PoweredByBlink />,
        ]
    }

    donate() {
        LoadingSpinner.show();

        const preferredPaymentMethodId = this.chooseCard.getActive().id;
        const payload = {
            amount: donateMobileState.getTotalAmount(),
            frequency: donateMobileState.getFrequency(),
            preferredPaymentMethodId,
            coversFees: donateMobileState.payDonationFeeCheckboxChecked,
        };
        donateMobileState.setPayload(payload);
        donateMobileState.donate(() => this.options.changeURL(DONATE_PAGE_URLS.thankYou),
            () => this.options.changeURL(DONATE_PAGE_URLS.paymentFailed, true));
    }

    onMount() {
        super.onMount();
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
